import React from 'react'
import { useDispatch, useSelector } from 'react-redux'

import history from '../../history'
import { decrypted } from '../../util/CryptoUtil'
import CompletarCadastroForm from './components/CompletarCadastroForm'
import { postCompletarCadastro } from '../../serviceAPI/completarcadastro';

function CompletarCadastro() {
    const dispatch = useDispatch();

    const userEncrypt = localStorage.getItem(process.env.REACT_APP_USER)
    const userDecrypt = decrypted(userEncrypt)
    const user = JSON.parse(userDecrypt)

    const endereco = useSelector(state => state.endereco)
    const contato = useSelector(state => state.contato)

    async function completarCadastro() {
        await postCompletarCadastro(endereco, contato, user, dispatch)
    }

    React.useEffect(() => {
        if(user.isCompleted === "True"){
            dispatch({
                type: 'OPEN_ALERT_DIALOG',
                title: 'Completar Cadastro',
                description: 'Seu cadastro já esta completo'
            })
            history.push('/inicial')
        }
    }, [user]);

    return (
        <div>
            <CompletarCadastroForm
                documento={user.document}
                nome={`${user.first_name} ${user.last_name}`}
                onSubmit={completarCadastro} />
        </div>
    )

}

export default CompletarCadastro;